import { Component, OnDestroy } from '@angular/core';
import { IdentityService } from 'identity';
import { NavigationService } from 'netview';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { UserDto } from 'UvExplorerServer.Dtos.TS/Auth';

@Component({
	selector: 'profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnDestroy {
	public name: string;
	private loginSub: Subscription;
	private logoutSub: Subscription;

	constructor(
		private identityService: IdentityService,
		private navService: NavigationService) {

		this.name = '';

		if (identityService.hasUser) {
			this.onLogin(identityService.user); 
		} 

		this.loginSub = identityService.onLogin.subscribe((user: UserDto) => {
			this.onLogin(user);
		});

		this.logoutSub = identityService.onLogout.subscribe(() => {
			this.onLogout();
		});
	}

	public ngOnDestroy(): void {
		if (this.loginSub) {
			this.loginSub.unsubscribe();
			this.loginSub = undefined;
		}
		if (this.logoutSub) {
			this.logoutSub.unsubscribe();
			this.logoutSub = undefined;
		}
	}

	public get isAdmin(): boolean {
		return this.identityService.isAdmin;
	}

	public logout(): void {
		this.identityService.logout();
	}

	private onLogin = (user: UserDto) => {
		this.name = `${user.FirstName} ${user.LastName}`;
	}

	private onLogout = () => {
		this.name = '';
	}

	public gotoAdmin(): void {
		this.navService.gotoAdmin();
	}

	//public gotoTools(): void {
	//	this.navService.gotoTools();
	//}

	public gotoAccount(): void {
		this.navService.gotoAccount();
	}

}